export default "__VITE_ASSET__D6VTUa73__";